/**
 * De btw-calculator op /btw-berekenen.
 *
 * Alles gebeurt in de browser: er gaat geen bedrag naar een server en er wordt
 * niets bewaard. De opmaak staat in resources/css/elements/btw-tools.css en het
 * geraamte in resources/views/sections/_btw_calculator.antlers.html, zodat de
 * pagina zonder JavaScript nog leesbaar blijft.
 */

const geld = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' });

const kaart = document.querySelector('[data-btwcalculator]');

if (kaart) {
    start(kaart);
}

function start(kaart) {
    const bedragveld = kaart.querySelector('[data-veld="bedrag"]');
    const uitExcl = kaart.querySelector('[data-uit="excl"]');
    const uitBtw = kaart.querySelector('[data-uit="btw"]');
    const uitIncl = kaart.querySelector('[data-uit="incl"]');
    const btwLabel = kaart.querySelector('[data-label="btw"]');
    const rekenregel = kaart.querySelector('[data-rekenregel]');
    const kopieerknop = kaart.querySelector('[data-actie="kopieer"]');
    const kopieerstatus = kaart.querySelector('[data-kopieerstatus]');

    let laatste = null;

    kaart.addEventListener('input', teken);
    kaart.addEventListener('change', teken);

    kopieerknop?.addEventListener('click', () => {
        kopieer(laatste, kopieerstatus);
    });

    teken();

    function teken() {
        const bedrag = leesBedrag(bedragveld.value);
        const tarief = gekozen(kaart, 'tarief');
        const richting = gekozen(kaart, 'richting');

        btwLabel.textContent = 'Btw ' + tarief + '%';

        if (bedrag === null) {
            uitExcl.textContent = uitBtw.textContent = uitIncl.textContent = '—';
            rekenregel.textContent = 'Vul een bedrag in, bijvoorbeeld 1250 of 1.250,00.';
            laatste = null;

            return;
        }

        laatste = reken(bedrag, tarief, richting);

        uitExcl.textContent = geld.format(laatste.excl);
        uitBtw.textContent = geld.format(laatste.btw);
        uitIncl.textContent = geld.format(laatste.incl);
        rekenregel.textContent = somVan(laatste, richting);
    }
}

/**
 * Nederlandse notatie: de komma scheidt de centen, de punt de duizendtallen.
 * Staat er alleen een punt, dan hangt het van het aantal punten af wat de
 * schrijver bedoelde; bij één punt met twee cijfers erachter leest de browser
 * hem als decimaalteken, zoals een geplakt bedrag uit een spreadsheet.
 */
function leesBedrag(waarde) {
    let ruw = waarde.trim().replace(/[\s€]/g, '');

    if (ruw === '') {
        return null;
    }

    if (ruw.includes(',')) {
        ruw = ruw.replace(/\./g, '').replace(',', '.');
    } else if ((ruw.match(/\./g) || []).length > 1) {
        ruw = ruw.replace(/\./g, '');
    }

    const getal = Number.parseFloat(ruw);

    return Number.isFinite(getal) && getal >= 0 ? getal : null;
}

function reken(bedrag, tarief, richting) {
    const factor = 1 + tarief / 100;

    if (richting === 'incl') {
        const incl = rond(bedrag);
        const excl = rond(bedrag / factor);

        return { excl, btw: rond(incl - excl), incl, tarief, factor };
    }

    const excl = rond(bedrag);
    const btw = rond(bedrag * (tarief / 100));

    return { excl, btw, incl: rond(excl + btw), tarief, factor };
}

/**
 * De som onder de uitkomst, zodat je kunt narekenen wat de calculator deed.
 */
function somVan(uitkomst, richting) {
    if (uitkomst.tarief === 0) {
        return 'Bij 0% btw blijft het bedrag gelijk.';
    }

    const factor = String(uitkomst.factor).replace('.', ',');

    return richting === 'incl'
        ? geld.format(uitkomst.incl) + ' ÷ ' + factor + ' = ' + geld.format(uitkomst.excl)
        : geld.format(uitkomst.excl) + ' × ' + factor + ' = ' + geld.format(uitkomst.incl);
}

function kopieer(uitkomst, status) {
    if (! uitkomst) {
        melden(status, 'Vul eerst een bedrag in.');

        return;
    }

    const tekst = 'Excl. btw: ' + geld.format(uitkomst.excl)
        + ' | Btw ' + uitkomst.tarief + '%: ' + geld.format(uitkomst.btw)
        + ' | Incl. btw: ' + geld.format(uitkomst.incl);

    /*
     * De clipboard-API bestaat alleen op een beveiligde verbinding en mag door de
     * browser geweigerd worden. Lukt het niet, dan zegt de tool dat, in plaats van
     * te doen alsof er iets op het klembord staat.
     */
    if (! navigator.clipboard?.writeText) {
        melden(status, 'Kopiëren lukt niet in deze browser. Selecteer de bedragen zelf.');

        return;
    }

    navigator.clipboard.writeText(tekst).then(
        () => melden(status, 'Gekopieerd.'),
        () => melden(status, 'Kopiëren lukte niet. Selecteer de bedragen zelf.')
    );
}

function melden(status, tekst) {
    status.textContent = tekst;

    window.setTimeout(() => {
        status.textContent = '';
    }, 4000);
}

function gekozen(kaart, naam) {
    const keuze = kaart.querySelector('input[name="' + naam + '"]:checked');
    const waarde = keuze ? keuze.value : '';

    return naam === 'tarief' ? Number.parseInt(waarde, 10) || 0 : waarde;
}

function rond(getal) {
    return Math.round((getal + Number.EPSILON) * 100) / 100;
}
